<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import pdf from 'vue-pdf';
import DatePicker from "vue2-datepicker";
import Multiselect from 'vue-multiselect';
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, pdf, Multiselect, DatePicker },
    data() {
        return {
            title: "Revision gastos",
            items: [
                {
                text: "Reembolsos",
                href: "/"
                },
                {
                text: "Revision gastos",
                active: true
                }
            ],
            reembolsos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            desde: '',
            hasta: '',
            coordinadorSeleccionado: [],
            tipoGastoSeleccionado: '',
            filtroSeleccionados: 'todos',
            filtroProcesados: 'no_procesados',
            direccion:'',
            extension:'',
            previewObjectUrl: '',
            archivoDisponible: true,
            archivoMensaje: '',
            valor_editar:{
                evento:'',
                tipo:'',
                monto:'$0',
                imagen:[],
                fecha:'',
                colegio:''
            },
            tipos:['Transporte local/Nacional','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Viajes Aereos'],
            imagenminiatura:'',
            colegiosFiltrados:[],
            eventoscolegiosFiltrados:[],
            eventosFiltrados:[],
            archivoPreview: '',
            tipoArchivo: '',
            todoseventos:[],
            eventos:[],
            colegios:[],
            cambiar:false,
            isLoadingReembolsos: false,
        };
    },
    computed:{
        rows() {
            return this.filteredData.length;
        },
        coordinadoresSeleccionadosFiltrables() {
            const coordinadores = Array.isArray(this.coordinadorSeleccionado)
                ? this.coordinadorSeleccionado
                : [this.coordinadorSeleccionado];

            return [...new Set(coordinadores.map((item) => (item || '').trim()).filter((item) => item !== ''))];
        },
        coordinadoresDisponibles() {
            return [...new Set(
                (this.reembolsos || [])
                    .map((item) => (item.coordinador_evento || '').trim())
                    .filter((item) => item !== '')
            )].sort((a, b) => a.localeCompare(b, 'es'));
        },
        tiposGastoDisponibles() {
            const tipos = [...new Set(
                (this.reembolsos || []).flatMap((item) => (item.gastos || []).map((gasto) => gasto.tipo_gasto || '')).filter((tipo) => tipo !== '')
            )].sort((a, b) => a.localeCompare(b, 'es'));

            return [
                { value: '', text: 'Todos los tipos' },
                ...tipos.map((tipo) => ({ value: tipo, text: tipo }))
            ];
        },
        filtroSeleccionadosOptions() {
            return [
                { value: 'no_seleccionados', text: 'No seleccionados' },
                { value: 'seleccionados', text: 'Seleccionados' },
                { value: 'todos', text: 'Todos' },
            ];
        },
        filtroProcesadosOptions() {
            return [
                { value: 'no_procesados', text: 'No procesados' },
                { value: 'procesados', text: 'Procesados' },
                { value: 'todos', text: 'Todos' },
            ];
        },
        puedeEditarProcesados() {
            return this.user && (this.user.rol === 'Admin' || this.user.rol === 'Supervisor');
        },
        comprobantesFiltradosCount() {
            return this.filteredData.reduce((total, item) => total + ((item.gastos || []).length), 0);
        },
        rangoFechasLabel() {
            if (!this.desde && !this.hasta) {
                return 'Todos los periodos';
            }

            const desde = this.desde ? moment(this.desde).format('DD-MM-YYYY') : 'Inicio';
            const hasta = this.hasta ? moment(this.hasta).format('DD-MM-YYYY') : 'Hoy';

            return `${desde} al ${hasta}`;
        },
        visibleRowsCount() {
            return this.paginatedData.length;
        },
        filteredData() {
            const filtro = (this.filtro || '').toLowerCase().trim();
            return (this.reembolsos || []).map((item) => {
                if (this.coordinadoresSeleccionadosFiltrables.length > 0 && !this.coordinadoresSeleccionadosFiltrables.includes((item.coordinador_evento || '').trim())) {
                    return null;
                }

                const gastosFiltrados = (item.gastos || []).filter((gasto) => {
                    if (this.tipoGastoSeleccionado && gasto.tipo_gasto !== this.tipoGastoSeleccionado) {
                        return false;
                    }

                    if (this.filtroSeleccionados === 'seleccionados' && String(gasto.status) !== '1') {
                        return false;
                    }

                    if (this.filtroSeleccionados === 'no_seleccionados' && String(gasto.status) === '1') {
                        return false;
                    }

                    if (this.filtroProcesados === 'no_procesados' && gasto.fecha_descarga) {
                        return false;
                    }

                    if (this.filtroProcesados === 'procesados' && !gasto.fecha_descarga) {
                        return false;
                    }

                    if (this.desde && moment(gasto.fecha).format('YYYY-MM-DD') < this.desde) {
                        return false;
                    }

                    if (this.hasta && moment(gasto.fecha).format('YYYY-MM-DD') > this.hasta) {
                        return false;
                    }

                    return true;
                });

                if (!gastosFiltrados.length) {
                    return null;
                }

                const textoBusqueda = [
                    item.codigo,
                    item.nombre_difusion,
                    item.coordinador_evento,
                    item.rbd_colegio,
                    item.colegio,
                    ...gastosFiltrados.map((gasto) => [gasto.tipo_gasto, gasto.fecha].join(' ')),
                ].join(' ').toLowerCase();

                if (filtro && !textoBusqueda.includes(filtro)) {
                    return null;
                }

                return {
                    ...item,
                    gastos: gastosFiltrados,
                };
            }).filter((item) => !!item);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    watch: {
        filtro() {
            this.currentPage = 1;
        },
        desde() {
            this.currentPage = 1;
        },
        hasta() {
            this.currentPage = 1;
        },
        coordinadorSeleccionado() {
            this.currentPage = 1;
        },
        tipoGastoSeleccionado() {
            this.currentPage = 1;
        },
        filtroSeleccionados() {
            this.currentPage = 1;
        },
        filtroProcesados() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        },
        filteredData(nuevosDatos) {
            const totalPaginas = Math.max(1, Math.ceil(nuevosDatos.length / this.perPage));

            if (this.currentPage > totalPaginas) {
                this.currentPage = totalPaginas;
            }
        },
    },
    methods:{
        resumenColegio(nombreColegio) {
            const nombre = String(nombreColegio || '').trim();

            if (!nombre) {
                return '-';
            }

            return nombre.length > 26 ? `${nombre.slice(0, 26).trim()}...` : nombre;
        },
        tituloColegio(nombreColegio) {
            const nombre = String(nombreColegio || '').trim();
            return nombre || 'Sin colegio';
        },
        filtrarReembolsosPorRol(eventos) {
            const eventosConGastos = (eventos || []).filter((evento) => evento.boolean == true);

            if (!this.user || !this.user.rol) {
                return eventosConGastos;
            }

            if (this.user.rol == 'Admin') {
                return eventosConGastos;
            }

            if (this.user.rol == 'Supervisor') {
                return eventosConGastos.filter((evento) => evento.sede_asociada == this.user.sede);
            }

            if (this.user.rol == 'Coordinador') {
                return eventosConGastos.filter((evento) => {
                    const coincidePorId = Number(evento.user_id) === Number(this.user.id);
                    const coincidePorNombre = (evento.coordinador_evento || '') === (this.user.name || '');
                    return coincidePorId || coincidePorNombre;
                });
            }

            return [];
        },
        cargarReembolsos() {
            this.isLoadingReembolsos = true;

            axios.get('/api/get_gastos').then(res => {
                this.reembolsos = this.filtrarReembolsosPorRol(res.data.eventos);
            }).catch(() => {
                this.reembolsos = [];
                this.msg('error', 'No se pudieron cargar los gastos');
            }).finally(() => {
                this.isLoadingReembolsos = false;
            });
        },
        resetArchivoPreview() {
            if (this.previewObjectUrl) {
                URL.revokeObjectURL(this.previewObjectUrl);
            }
            this.previewObjectUrl = '';
            this.direccion = '';
            this.extension = '';
            this.archivoDisponible = true;
            this.archivoMensaje = '';
        },
        isProtectedExpenseUrl(url) {
            return typeof url === 'string' && url.startsWith('/api/gasto_archivo/');
        },
        getEncodedFileUrl(url) {
            if (!url) {
                return '';
            }

            return url
                .split('/')
                .map((segment, index) => {
                    if (index === 0 && segment === '') {
                        return '';
                    }

                    return encodeURIComponent(segment);
                })
                .join('/');
        },
        async resolveProtectedExpenseUrl(fileUrl) {
            const encodedUrl = this.getEncodedFileUrl(fileUrl);

            try {
                const response = await axios.get(encodedUrl, {
                    responseType: 'blob',
                    validateStatus: () => true,
                });

                if (response.status >= 200 && response.status < 300) {
                    this.previewObjectUrl = URL.createObjectURL(response.data);
                    return {
                        disponible: true,
                        url: this.previewObjectUrl,
                    };
                }

                let mensaje = 'No se pudo cargar el comprobante.';
                try {
                    const rawText = response.data instanceof Blob ? await response.data.text() : '';
                    const parsed = rawText ? JSON.parse(rawText) : null;
                    mensaje = parsed && parsed.mensaje ? parsed.mensaje : mensaje;
                } catch (error) {
                    mensaje = response.status === 403
                        ? 'No autorizado'
                        : mensaje;
                }

                return {
                    disponible: false,
                    mensaje,
                };
            } catch (error) {
                const mensaje = error && error.response && error.response.data && error.response.data.mensaje
                    ? error.response.data.mensaje
                    : 'No se pudo cargar el comprobante.';

                return {
                    disponible: false,
                    mensaje,
                };
            }
        },
        async prepareFilePreview(item) {
            this.resetArchivoPreview();

            if (!item) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El gasto no tiene comprobante asociado.';
                return;
            }

            const fileUrl = item.comprobante_local_disponible === false && item.imagen_url_respaldo
                ? item.imagen_url_respaldo
                : (item.imagen_url || item.imagen_url_respaldo || '');

            if (!fileUrl) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El comprobante no está disponible ni localmente ni en S3.';
                return;
            }

            const extension = fileUrl.split('.').pop().toLowerCase();
            const encodedUrl = this.getEncodedFileUrl(fileUrl);

            this.extension = extension === 'pdf' ? 'pdf' : '';

            if (this.isProtectedExpenseUrl(fileUrl)) {
                const resultado = await this.resolveProtectedExpenseUrl(fileUrl);
                this.archivoDisponible = resultado.disponible;
                this.archivoMensaje = resultado.mensaje || '';
                this.direccion = resultado.url || '';
                return;
            }

            this.direccion = encodedUrl;
        },
        ver_mas(item){
            this.$set(item, 'boton', item.boton === 'Ver más' ? 'Ver menos' : 'Ver más');
        },
        totalGastosEvento(item) {
            if (!item || !Array.isArray(item.gastos) || item.gastos.length === 0) {
                return this.format_Valor_variable(0);
            }
            const total = item.gastos.reduce((acumulado, gasto) => {
                const monto = parseInt(String(gasto && gasto.monto ? gasto.monto : 0).replace(/[^0-9]/g, ''), 10) || 0;
                return acumulado + monto;
            }, 0);
            return this.format_Valor_variable(total);
        },
        async ver_comprobante(item){
            await this.prepareFilePreview(item);
            this.$refs['modal-imagen'].show();
        },
        async aprobar_gasto(item){
            const estadoPrevio = String(item && item.status !== undefined ? item.status : '0');
            let formData = new FormData();
            formData.append('gasto_id', item.id);
            formData.append('status', item.status);

            try {
                const response = await axios.post('/api/seleccionar_gasto',formData);
                if (!response.data || !response.data.estado) {
                    throw new Error('No se pudo actualizar el estado del comprobante');
                }

                this.msg('success', String(item.status) === '1' ? 'Comprobante seleccionado' : 'Comprobante deseleccionado');
            } catch (error) {
                // Revertimos el checkbox si el backend no guardó.
                this.$set(item, 'status', estadoPrevio);
                this.msg('error', 'No se pudo guardar la selección');
            }
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        async modal_editar(item){
            this.valor_editar.id = item.id;
            this.valor_editar.fecha = item.fecha;
            this.valor_editar.evento = this.todoseventos.filter(evento => evento.id==item.evento_id);
            this.valor_editar.colegio = this.colegios.filter(colegio => colegio.rbd==this.valor_editar.evento[0].rbd_colegio);
            this.valor_editar.monto = item.monto;
            this.valor_editar.tipo = item.tipo_gasto;
            await this.prepareFilePreview(item);
            this.$refs['modal-editar'].show();
        },
        filtro_colegios() {
            if (!this.valor_editar.fecha) return;
            // Filtrar eventos por la fecha seleccionada
            this.eventoscolegiosFiltrados = this.eventos.filter(
                (evento) => moment(evento.fecha_inicio).format('YYYY-MM-DD') === this.valor_editar.fecha
            );
            // Extraer RBD únicos y asegurarnos de que sean cadenas para evitar problemas de comparación
            const rbdUnicos = [...new Set(this.eventoscolegiosFiltrados.map(evento => String(evento.rbd_colegio).trim()))];
            // Filtrar colegios con los RBD obtenidos
            this.colegiosFiltrados = this.colegios.filter(colegio =>
                rbdUnicos.includes(String(colegio.rbd).trim())
            );
        },
        filtro_eventos(){
            this.eventosFiltrados = this.eventoscolegiosFiltrados.filter(
                (evento) => evento.rbd_colegio == this.valor_editar.colegio.rbd
            );
        },
        disabledBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today ;
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        labelColegio(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        obtenerImagen(e){
            let file = e.target.files[0];
            if (!file) return;
            this.valor_editar.imagen = file;
            this.cargarImagen(file);
        },
        abrirSelectorDocumentoEditar() {
            if (this.$refs.inputDocumentoEditar) {
                this.$refs.inputDocumentoEditar.click();
            }
        },
        limpiarDocumentoEditar() {
            this.valor_editar.imagen = null;
            this.imagenminiatura = '';
            this.tipoArchivo = '';
            if (this.$refs.inputDocumentoEditar) {
                this.$refs.inputDocumentoEditar.value = '';
            }
        },
        cargarImagen(file){
            let reader = new FileReader();
            // Verificar el tipo de archivo
            if (file.type.includes("image")) {
                this.tipoArchivo = "imagen";
            } else if (file.type.includes("pdf")) {
                this.tipoArchivo = "pdf";
            } else {
                this.tipoArchivo = "";
                return;
            }
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        format_Valor(){
            this.valor_editar.monto=this.format_Valor_variable(this.valor_editar.monto);
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        limpiarFiltros() {
            this.desde = '';
            this.hasta = '';
            this.coordinadorSeleccionado = [];
            this.tipoGastoSeleccionado = '';
            this.filtroSeleccionados = 'no_seleccionados';
            this.filtroProcesados = 'no_procesados';
            this.filtro = '';
        },
        btn_cambiar(){
            this.cambiar=!this.cambiar;
            if (!this.cambiar) {
                this.limpiarDocumentoEditar();
            }
        },
        editar(){
            let formData = new FormData();
            formData.append('id', this.valor_editar.id);
            formData.append('tipo', this.valor_editar.tipo);
            formData.append('monto', this.valor_editar.monto);
            formData.append('imagen', this.valor_editar.imagen);
            axios.post('/api/editar_gastos',formData).then(res=>{
                if(res.data.estado){
                    this.valor_editar.fecha='';
                    this.valor_editar.colegio='';
                    this.valor_editar.evento='';
                    this.valor_editar.tipo='';
                    this.valor_editar.monto='$0';
                    this.valor_editar.imagen=[];
                    this.imagenminiatura='';
                    this.tipoArchivo='';
                    this.msg('success','Gasto editado correctamente');
                    this.cargarReembolsos();
                }else{
                    this.msg('error','Gasto No editado');
                }
            });
        },
        eliminar(item){
            let formData = new FormData();
            formData.append('gasto_id', item.id);
            Swal.fire({
                title: "¿Está seguro que desea eliminar este gasto?",
                text: "¡No podrás revertir esto! ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#C87838",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, estoy seguro"
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/eliminar_gastos',formData).then(response => {
                        if (response.data.estado) {
                            Swal.fire({
                                title: "Eliminado",
                                text: "La información ha sido borrada",
                                icon: "success",
                                showConfirmButton: false,
                                timer: 1000
                            });
                            this.cargarReembolsos();
                        }
                    });
                }
            });
        }
    },
    created(){
        this.cargarReembolsos();
        axios.get('/api/get_eventos').then(res=>{
            this.todoseventos=res.data.eventos
            this.eventos = res.data.eventos.filter(evento => new Date(evento.fecha_inicio) <= new Date());
        });
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.colegios = response.data.colegios;
            }
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message
            v-if="isLoadingReembolsos"
            title="Cargando revision de gastos"
            subtitle="Estamos trayendo los datos de reembolsos. Esto puede tardar unos segundos."
        />
        <div class="row">
            <div class="col-12" v-if="!isLoadingReembolsos && (reembolsos.length > 0 || filtro)">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <b-form-group label="Desde">
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-3">
                                <b-form-group label="Hasta">
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-3">
                                <b-form-group label="Coordinador">
                                    <multiselect
                                        v-model="coordinadorSeleccionado"
                                        :options="coordinadoresDisponibles"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        :show-labels="false"
                                        placeholder="Todos los coordinadores"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                    >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="col-md-3">
                                <b-form-group label="Tipo de gasto">
                                    <b-form-select v-model="tipoGastoSeleccionado" :options="tiposGastoDisponibles"></b-form-select>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <b-form-group label="Seleccion">
                                    <b-form-select v-model="filtroSeleccionados" :options="filtroSeleccionadosOptions"></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-3">
                                <b-form-group label="Procesados">
                                    <b-form-select v-model="filtroProcesados" :options="filtroProcesadosOptions"></b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group label="Buscar evento, codigo, RBD, coordinador o tipo">
                                    <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar... (incluye RBD)"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-2 d-flex align-items-end justify-content-md-end">
                                <b-button variant="outline-secondary" @click="limpiarFiltros">Limpiar filtros</b-button>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 col-sm-6 mb-2">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Rango visible</small>
                                    <strong>{{ rangoFechasLabel }}</strong>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-6 mb-2">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Eventos visibles</small>
                                    <strong>{{ rows }}</strong>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 mb-2">
                                <div class="border rounded p-3 h-100 bg-light">
                                    <small class="text-muted d-block">Comprobantes visibles</small>
                                    <strong>{{ comprobantesFiltradosCount }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <div class="d-inline-flex align-items-center flex-nowrap">
                                        <span>Mostrar</span>
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="w-auto mx-2"></b-form-select>
                                        <span>eventos de {{ rows }} registros visibles</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right text-muted pt-2">
                                    Mostrando {{ comprobantesFiltradosCount }} comprobante(s) en {{ rows }} evento(s)
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table tabla-eventos-gastos mb-0">
                                <thead>
                                    <tr>
                                        <th class="columna-numero">Nº</th>
                                        <th class="columna-evento">Evento</th>
                                        <th class="columna-rbd">RBD</th>
                                        <th class="columna-colegio">Colegio</th>
                                        <th class="columna-coordinador">Coordinador</th>
                                        <th class="columna-comprobantes">Comprobantes</th>
                                        <th class="columna-total">Total</th>
                                        <th class="columna-accion">Acción</th>
                                    </tr>
                                </thead>
                                <tbody v-for="(item, index) in paginatedData" :key="item.id || index">
                                    <tr class="evento-resumen-row">
                                        <td class="columna-numero">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
                                        <td class="columna-evento">{{ item.codigo}}</td>
                                        <td class="columna-rbd">{{ item.rbd_colegio || '-' }}</td>
                                        <td class="columna-colegio">
                                            <span class="texto-resumido" :title="tituloColegio(item.colegio)">{{ resumenColegio(item.colegio) }}</span>
                                        </td>
                                        <td class="columna-coordinador">{{ item.coordinador_evento }}</td>
                                        <td class="columna-comprobantes">{{ (item.gastos || []).length }}</td>
                                        <td class="columna-total">{{ totalGastosEvento(item) }}</td>
                                        <td class="columna-accion">
                                            <b-button v-b-toggle="'accordion-'+item.id" variant="secondary" @click="ver_mas(item)">{{item.boton}}</b-button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="8" class="p-0 border-0">
                                            <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                                                <div class="row">
                                                    <div class="col-md-12" >
                                                        <div class="card mt-3 shadow-sm border-0 comprobantes-panel">
                                                            <div class="card-body">
                                                                <div class="comprobantes-panel__header">
                                                                    <div>
                                                                        <div class="comprobantes-panel__eyebrow">Detalle del evento</div>
                                                                        <h6 class="mb-1">Comprobantes de {{ item.codigo }}</h6>
                                                                        <small :title="tituloColegio(item.colegio)">{{ tituloColegio(item.colegio) }}</small>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <div class="table-responsive mb-0 mt-3">
                                                                            <table class="table table-sm mb-0">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th style="width: 5%;">Nº</th>
                                                                                        <th style="width: 5%;">Seleccionar</th>
                                                                                        <th style="width: 8%;">Tipo Gasto</th>
                                                                                        <th style="width: 10%;">Monto</th>
                                                                                        <th style="width: 20%;">Comprobante</th>
                                                                                        <th style="width: 20%;">Acciones</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr v-for="(item2, index2) in item.gastos" :key="index2">
                                                                                        <td>{{ index2+1 }}</td>
                                                                                        <td>
                                                                                            <b-form-checkbox
                                                                                            :id="'checkbox-'+index2+'-'+index"
                                                                                            v-model="item2.status"
                                                                                            value="1"
                                                                                            unchecked-value="0"
                                                                                            @change="aprobar_gasto(item2)"
                                                                                            :disabled="!!(item2.fecha_descarga) && !puedeEditarProcesados"
                                                                                            >
                                                                                            </b-form-checkbox>
                                                                                        </td>
                                                                                        <td>{{ item2.tipo_gasto}}</td>
                                                                                        <td>{{ item2.monto }}</td>
                                                                                        <td>
                                                                                            <b-button v-if="item2.comprobante_disponible" variant="primary" @click="ver_comprobante(item2)" size="sm">Ver</b-button>
                                                                                            <span v-else class="badge badge-secondary" title="El archivo fue subido con el sistema anterior y ya no está disponible en el servidor">Sin archivo</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <b-button variant="primary" @click="modal_editar(item2)" v-if="!item2.fecha_descarga || puedeEditarProcesados">Editar</b-button>
                                                                                            <b-button variant="danger" @click="eliminar(item2)" v-if="!item2.fecha_descarga || puedeEditarProcesados"><i class="bx bx-trash"></i></b-button>
                                                                                            <span v-if="item2.fecha_descarga && !puedeEditarProcesados" class="badge badge-secondary">Procesado</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!paginatedData.length" class="py-4 text-center text-muted">
                            <h5 class="mb-2">No se encontraron resultados</h5>
                            <p class="mb-0">Ajusta el texto de busqueda para intentar nuevamente.</p>
                        </div>
                        <div class="text-muted mb-3" v-if="rows">
                            Mostrando {{ visibleRowsCount }} recibos de {{ rows }} registros.
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                            <div v-if="!archivoDisponible" class="alert alert-warning mb-0">
                                {{ archivoMensaje }}
                            </div>
                            <pdf :src="direccion" v-else-if="extension=='pdf'"></pdf>
                            <img :src="direccion" width="100%" v-else>
                        </b-modal>
                        <b-modal ref="modal-editar" title="Editar Gasto" ok-title="Guardar" cancel-title="Cancelar" @ok="editar">
                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Fecha:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <date-picker v-model="valor_editar.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" :disabled-date="disabledBeforeToday" @change="filtro_colegios" disabled></date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Colegio:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <multiselect
                                                v-model="valor_editar.colegio"
                                                :options="colegiosFiltrados"
                                                placeholder="Seleccionar colegio"
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                :custom-label="labelColegio"
                                                disabled
                                                @select="filtro_eventos"
                                                >
                                                <template v-slot:noOptions>
                                                    <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Evento:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <multiselect
                                                v-model="valor_editar.evento"
                                                :options="eventosFiltrados"
                                                placeholder="Seleccionar evento"
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                :custom-label="labelEvento"
                                                disabled
                                                >
                                                <template v-slot:noOptions>
                                                    <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Tipo de gasto:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <multiselect
                                                v-model="valor_editar.tipo"
                                                :options="tipos"
                                                placeholder="Seleccionar tipo"
                                                selectLabel="Presiona para seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Presiona para remover"
                                                >
                                                <template v-slot:noOptions>
                                                    <p>No hay opciones</p>
                                                </template>
                                                <template v-slot:noResult>
                                                    <p>No se encuentra coincidencia</p>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label for="pais"> Monto del Gasto:</label>
                                        </div>
                                        <div class="col-md-12">
                                            <b-form-input v-model="valor_editar.monto" class="border-primary" @input="format_Valor"></b-form-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <b-button :variant="cambiar?'secondary':'primary'" @click="btn_cambiar">{{ cambiar ? 'No Cambiar' : 'Cambiar Documento'}}</b-button>
                                    <div v-if="!cambiar">
                                        <div v-if="!archivoDisponible" class="alert alert-warning mt-3 mb-0">
                                            {{ archivoMensaje }}
                                        </div>
                                        <pdf :src="direccion" v-else-if="extension=='pdf'"></pdf>
                                        <img :src="direccion" width="100%" v-else>
                                    </div>
                                    <div class="row" v-else>
                                        <div class="col-md-12">
                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label for="pais"> Documento Asociado:</label>
                                                </div>
                                                <div class="col-md-12">
                                                    <input
                                                        ref="inputDocumentoEditar"
                                                        type="file"
                                                        class="d-none"
                                                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                                                        @change="obtenerImagen"
                                                    >
                                                    <div class="carga-documento-mejorada" @click="abrirSelectorDocumentoEditar">
                                                        <div>
                                                            <strong>{{ valor_editar.imagen ? valor_editar.imagen.name : 'Ningun archivo seleccionado' }}</strong>
                                                            <div class="text-muted small">Formatos permitidos: JPG, PNG y PDF. Tamano maximo: 2 MB.</div>
                                                        </div>
                                                        <div class="carga-documento-mejorada__acciones">
                                                            <b-button variant="outline-primary" @click.stop="abrirSelectorDocumentoEditar">
                                                                {{ valor_editar.imagen ? 'Cambiar archivo' : 'Elegir archivo' }}
                                                            </b-button>
                                                            <b-button v-if="valor_editar.imagen" variant="outline-secondary" @click.stop="limpiarDocumentoEditar">
                                                                Quitar
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="offset-md-1 col-md-10 text-center">
                                            <figure v-if="tipoArchivo === 'imagen'">
                                                <img :src="imagenminiatura" height="auto" alt="Imagen del producto">
                                            </figure>
                                            <div v-if="tipoArchivo === 'pdf'">
                                                <pdf :src="imagenminiatura"></pdf>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
            <div class="col-12" v-else-if="!isLoadingReembolsos">
                <div class="card">
                    <div class="card-body">
                        <h4 class="text-center">No hay gastos agregados</h4>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>
.carga-documento-mejorada {
    border: 1px dashed #d8c1aa;
    border-radius: 0.5rem;
    padding: 1rem;
    background: #fcfaf7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    cursor: pointer;
}

.carga-documento-mejorada__acciones {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.tabla-eventos-gastos {
    width: 100%;
    table-layout: auto;
}

.tabla-eventos-gastos th,
.tabla-eventos-gastos td {
    vertical-align: top;
}

.tabla-eventos-gastos .columna-numero {
    width: 6%;
}

.tabla-eventos-gastos .columna-evento {
    width: 12%;
    white-space: nowrap;
}

.tabla-eventos-gastos .columna-rbd {
    width: 10%;
    white-space: nowrap;
}

.tabla-eventos-gastos .columna-colegio {
    width: 16%;
    white-space: nowrap;
}

.tabla-eventos-gastos .columna-coordinador {
    width: 14%;
    white-space: nowrap;
}

.tabla-eventos-gastos .columna-comprobantes {
    width: 12%;
    white-space: nowrap;
}

.tabla-eventos-gastos .columna-total {
    width: 12%;
    white-space: nowrap;
}

.tabla-eventos-gastos .columna-accion {
    width: 20%;
    white-space: nowrap;
}

.evento-resumen-row {
    background: #fffdf8;
}

.texto-resumido {
    display: inline-block;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
}

.comprobantes-panel {
    background: linear-gradient(180deg, #fffaf2 0%, #ffffff 100%);
    border-left: 4px solid #c87838;
}

.comprobantes-panel__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding-bottom: 0.9rem;
    margin-bottom: 0.9rem;
    border-bottom: 1px solid #eadbc8;
}

.comprobantes-panel__eyebrow {
    font-size: 0.72rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #9b6a3f;
    margin-bottom: 0.25rem;
}

@media (max-width: 767px) {
    .carga-documento-mejorada {
        flex-direction: column;
        align-items: flex-start;
    }

    .tabla-eventos-gastos {
        min-width: 1080px;
    }

    .texto-resumido {
        max-width: 220px;
    }
}
</style>
